import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import ArrowIcon from '../assets/images/icon-arrow-right-circle.svg'

const propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  url: PropTypes.string,
}

const ServiceItem = ({ title, text, url }) => (
  <li className="service-item">
    <h3 className="title title--sm">{title}</h3>
    <p className="text">{text}</p>
    {url && (
      <Link className="service-item__button" to={url}>
        <span className="service-item__button-text">Learn More</span>
        <img className="service-item__icon" src={ArrowIcon} alt="Arrow" />
      </Link>
    )}
  </li>
)

ServiceItem.propTypes = propTypes

export default ServiceItem



// WEBPACK FOOTER //
// ./src/components/ServiceItem.js